import { render, staticRenderFns } from "./AmountDebt.vue?vue&type=template&id=61b5e1f3&"
import script from "./AmountDebt.vue?vue&type=script&lang=js&"
export * from "./AmountDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports